import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  BackgroundWrapperStyles,
  BackgroundStyles,
  BannerWrapperStyles,
  ContentWrapperStyles,
  ContentStyles,
  ContentDescriptionStyles,
  ContentButtonsStyles,
} from "./full-width-banners-styles"
import { BreakPoints, media } from "../../helpers/rwd"

interface IBackgroundWrapper {
  imgSrc: string
}

interface IContentWrapper {
  height: number | undefined
}

export const SectionWrapper = styled.section`
  display: flex;
  position: relative;
  width: 100%;
  min-height: 400px;
  ${SectionWrapperStyles}
`

export const BackgroundWrapper = styled.div`
  display: flex;
  position: absolute;
  align-items: stretch;
  width: 100%;
  height: 100%;
  z-index: 1;
  ${media.max(BreakPoints.desktop)} {
    flex-direction: column;
  }
  ${media.max(BreakPoints.tablet)} {
    -webkit-box-align: center;
    align-items: center;
  }
  ${BackgroundWrapperStyles}
`

export const Background = styled.div<IBackgroundWrapper>`
  background-image: url(${props => props.imgSrc});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  max-width: 495px;
  &:first-child {
    max-width: none;
  }
  &:last-child {
    max-width: none;
  }
  ${media.max(BreakPoints.desktop)} {
    height: 100%;
    margin-top: 0px;
  }
  ${BackgroundStyles}
`

export const BannerTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-weight: 900;
  font-size: 3em;
  text-transform: uppercase;
  max-width: 450px;
  text-align: right;
  line-height: 1.2em;
  text-shadow: 2px 2px 5px black;
`

export const BannerWrapper = styled.div`
  ${BannerWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)<IContentWrapper>`
  display: flex;
  align-items: center;
  min-height: ${props => `${props.height || 400}px`};
  z-index: 2;
  ${media.max(BreakPoints.desktop)} {
    flex-direction: column;
  }
  ${ContentWrapperStyles}
`

export const Content = styled.div`
  width: 100%;
  margin: 50px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  ${media.max(BreakPoints.desktop)} {
    margin-left: 0;
    margin-right: 0;
  }
  ${ContentStyles}
`

export const ContentDescription = styled.p`
  margin: 30px 0;
  ${ContentDescriptionStyles}
`

export const ContentButtons = styled.div`
  display: flex;
  & > a {
    margin-right: 30px;
  }
  & > a:last-child {
    margin-right: 0;
  }
  ${media.max(BreakPoints.tablet)} {
    flex-wrap: wrap;
    & > a {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  ${ContentButtonsStyles}
`
